import { userHandler } from "./userHandler";
import { groupHandler } from "./groupHandler";

export const ENTITY_HANDLERS = {
  User: userHandler,
  Group: groupHandler,
};
